import * as m from '~/paraglide/messages'
import type { Event } from '~/shared/types'

export function eventPriceLabel(price: Event['price']): string {
  if (price.kind === 'fixed') return `€${price.priceFixed}`
  if (price.kind === 'range') return `€${price.priceRangeMin} – €${price.priceRangeMax}`
  if (price.kind === 'free') return m.free()
  return m.priceUnknown()
}
